"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var OtherRequestItem = function (_a) {
    var request = _a.request;
    return (react_1.default.createElement("a", { href: request.messages_path, className: "usersEstimatesMessagesOtherRequest-OtherRequestItem" },
        react_1.default.createElement("div", { className: "usersEstimatesMessagesOtherRequest-OtherRequestItem_StoreInfo" },
            react_1.default.createElement("img", { src: request.store_logo_url, alt: request.store_name, className: "usersEstimatesMessagesOtherRequest-OtherRequestItem_StoreLogo lazyload" }),
            react_1.default.createElement("span", { className: "usersEstimatesMessagesOtherRequest-OtherRequestItem_StoreName" }, request.store_name)),
        react_1.default.createElement("div", { className: "usersEstimatesMessagesOtherRequest-OtherRequestItem_ItemNameWrapper" },
            react_1.default.createElement("span", { className: "usersEstimatesMessagesOtherRequest-OtherRequestItem_ItemName" }, request.item_name),
            request.item_count > 1 && react_1.default.createElement("span", null,
                "\u3001\u4ED6",
                request.item_count - 1,
                "\u70B9")),
        react_1.default.createElement("div", { className: "usersEstimatesMessagesOtherRequest-OtherRequestItem_PriceRangeWrapper" },
            react_1.default.createElement("span", { className: "usersEstimatesMessagesOtherRequest-OtherRequestItem_PriceRangeLabel" }, "\u5408\u8A08:"),
            react_1.default.createElement("span", { className: "usersEstimatesMessagesOtherRequest-OtherRequestItem_PriceRangeSum" }, request.price_range_sum)),
        request.have_unread_message &&
            react_1.default.createElement("span", { className: "usersEstimatesMessagesOtherRequest-OtherRequestItem_UnreadIcon" }),
        react_1.default.createElement("i", { className: "fa fa-chevron-right usersEstimatesMessagesOtherRequest-OtherRequestItem_Arrow" })));
};
exports.default = OtherRequestItem;
